export const FORMATION_LESSONS_AR = [
  {
    id: 'formation-1',
    numero: 1,
    titre: "فهم حساب التدريب الشخصي CPF",
    sousTitre: "حقوقك في التدريب",
    contexte: "لكل موظف في فرنسا حساب تدريب شخصي يتراكم مع كل سنة عمل. إليك كيف يعمل.",
    explication: [
      "**CPF** (Compte Personnel de Formation): حساب شخصي يتراكم فيه رصيد تدريب — 500 أورو في السنة كموظف كامل.",
      "**من يستفيد؟** كل موظف أو باحث عن عمل — منذ سن 16 وحتى التقاعد.",
      "**ما يمول؟** التدريب المهني، الحصول على شهادات، دروس قيادة، إتقان لغات أجنبية...",
      "**الحساب لا يضيع**: رصيدك يبقى حتى بعد تغيير الوظيفة أو فترات البطالة.",
      "**الحد الأقصى**: يمكن تراكم حتى 5000 أورو (8000 للعمال ذوي المهارات المحدودة).",
    ],
    question: "كم يُضاف لحساب CPF سنوياً للموظف الكامل؟",
    options: [
      { id: 'a', text: "500 أورو في السنة", correct: true },
      { id: 'b', text: "1000 أورو في السنة", correct: false },
      { id: 'c', text: "250 أورو في الشهر", correct: false },
    ],
    explication_reponse: "الموظف الكامل يجمع 500 أورو سنوياً. للعمال ذوي المهارات المحدودة (sans qualification): 800 أورو. الرصيد يتراكم ويبقى ملكك.",
  },
  {
    id: 'formation-2',
    numero: 2,
    titre: "استخدام Mon Compte Formation",
    sousTitre: "خطوة بخطوة",
    contexte: "لديك رصيد CPF. كيف تجد تدريباً مناسباً وتحجزه مباشرة عبر الإنترنت؟",
    explication: [
      "**الموقع الرسمي**: moncompteformation.gouv.fr — مجاني، بلا وسيط. احذر من المواقع الوسيطة التي تأخذ عمولة.",
      "**إنشاء حسابك**: برقم الضمان الاجتماعي وعنوان البريد الإلكتروني. فعّله بالكود المُرسل إلى هاتفك.",
      "**البحث عن تدريب**: استخدم خانة البحث بالكلمات المفتاحية — 'Excel'، 'anglais'، 'informatique'.",
      "**التحقق من الاعتماد**: تأكد أن التدريب يحمل اعتمادات رسمية (Qualiopi، RNCP) قبل الحجز.",
      "**الحجز المباشر**: إذا كان رصيدك كافياً، ادفع مباشرة بـ CPF دون إخراج أي مال من جيبك.",
    ],
    question: "أين تسجّل للحصول على تدريب ممول بـ CPF؟",
    options: [
      { id: 'a', text: "على moncompteformation.gouv.fr مباشرة", correct: true },
      { id: 'b', text: "في مكتب Pôle emploi", correct: false },
      { id: 'c', text: "عبر صاحب العمل فقط", correct: false },
    ],
    explication_reponse: "moncompteformation.gouv.fr هو الموقع الرسمي الوحيد. يمكنك البحث والحجز والدفع مباشرة بدون وسيط.",
  },
  {
    id: 'formation-3',
    numero: 3,
    titre: "التدريب أثناء العمل",
    sousTitre: "حقوقك مع صاحب العمل",
    contexte: "تريد التدرب وأنت لا تزال تعمل. ما خياراتك؟",
    explication: [
      "**خطة تطوير الكفاءات**: صاحب العمل ملزم بتدريبك للحفاظ على قدرتك المهنية. اطلب ذلك خلال مقابلتك المهنية.",
      "**إجازة التدريب Pro-A**: تسمح لك بالتدريب مع الاحتفاظ بأجرك — بشرط موافقة صاحب العمل.",
      "**التدريب خارج أوقات العمل**: يمكنك التدرب مساءً أو في عطل نهاية الأسبوع بـ CPF دون إخبار صاحب عملك.",
      "**مقابلة مهنية كل سنتين**: صاحب العمل ملزم بإجرائها. فرصة لطلب التدريب أو التطور.",
      "**رفض صاحب العمل**: إذا رفض التدريب بدون مبرر معقول، يمكنك الشكوى لـ DREETS (مديرية العمل).",
    ],
    question: "هل يمكنك التدرب بـ CPF دون إخبار صاحب عملك؟",
    options: [
      { id: 'a', text: "نعم، إذا كان التدريب خارج أوقات العمل", correct: true },
      { id: 'b', text: "لا، موافقة صاحب العمل إلزامية دائماً", correct: false },
      { id: 'c', text: "نعم دائماً، حتى أثناء أوقات العمل", correct: false },
    ],
    explication_reponse: "التدريب خارج أوقات العمل (مساءً، عطل نهاية الأسبوع) يمكن تمويله بـ CPF دون إخبار صاحب العمل. التدريب أثناء العمل يحتاج موافقته.",
  },
  {
    id: 'formation-4',
    numero: 4,
    titre: "مكافحة الاحتيال في التدريب",
    sousTitre: "احمِ رصيدك",
    contexte: "الاحتيال على حسابات CPF منتشر جداً. كيف تحمي رصيدك من السرقة؟",
    explication: [
      "**الاحتيال الشائع**: اتصال هاتفي يعرض تدريباً 'مجانياً' ويطلب رقم ضمانك الاجتماعي لـ 'التسجيل'.",
      "**لا تعطِ رقم ضمانك** لأي شخص يتصل بك بشكل عشوائي — حتى لو ادّعى أنه من Pôle emploi.",
      "**تحقق من رصيدك**: سجّل الدخول بانتظام على moncompteformation.gouv.fr للتأكد أن رصيدك سليم.",
      "**إذا اكتُشف الاحتيال**: أبلّغ فوراً على moncompteformation.gouv.fr ← 'signaler une fraude' أو اتصل بـ 0970 24 00 48.",
      "**قاعدة ذهبية**: أي عرض تدريب 'مجاني يُمول نفسه بنفسه من CPF' عبر هاتف غير مُطلوب هو احتيال.",
    ],
    question: "شخص اتصل بك يعرض تدريباً مجانياً ويطلب رقم ضمانك الاجتماعي. ماذا تفعل؟",
    options: [
      { id: 'a', text: "ارفض وأغلق الخط — إنه احتيال", correct: true },
      { id: 'b', text: "أعطِ الرقم إذا بدا العرض مثيراً للاهتمام", correct: false },
      { id: 'c', text: "اطلب معلومات إضافية قبل الإعطاء", correct: false },
    ],
    explication_reponse: "هذا النوع من الاتصالات دائماً احتيال. لا توجد هدايا مجانية في CPF. أغلق الخط وبلّغ على 0970 24 00 48.",
  },
];
